const Header = () => {
  return (
    <div>
      <h1 className="Header">Create a burger!</h1>
      <br />
    </div>
  );
};

export default Header;
